export default __webpack_public_path__ + "static/media/gallery_19.925d9cc5.jpg";